import React from 'react';
import { StyledHeaderContainer, StyledLink } from './style';
import Icon from '../../Icon';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import useCreditsStore from '../../../../Store/Credits';

type AppHeaderType = {
  title?: string;
  prevUrl?: string;
  goBack?: boolean;
  titleOption?: Record<string, string>;
};
const AppHeader: React.FC<AppHeaderType> = ({
  title,
  prevUrl,
  goBack,
  titleOption
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const setDataLength = useCreditsStore((state) => state.setDataLength);

  return (
    <StyledHeaderContainer>
      {t(`navigationBar.${title}`, titleOption)}
      <StyledLink to={!goBack && '/notifications'} goBack={goBack}>
        <Icon
          name={goBack ? 'arrow-left' : 'email_inbox'}
          fontSize={14}
          color={goBack ? 'danger' : 'secondaryText'}
          onClick={(): void => {
            setDataLength(10);
            goBack && navigate(-1);
          }}
        />
      </StyledLink>
    </StyledHeaderContainer>
  );
};

export default AppHeader;
